module.exports = __webpack_public_path__ + "static/FBAPICredentials-5fd66a49a1b3d6e627f095bd7c87eadd.png";